import React from 'react'
import { localized } from '@/decorators/localized'
import { Main, MainTop, MainTopTitle, MainBody, MainTopLeft } from '@/components/Layout'
import { BsrsGrid, EnumFilterCell, EnumCell, NameColumn, actionButtonsColumnProps, DateCell, DateFilterCell } from '@/components/BsrsGrid'
import { GridColumn as Column } from '@progress/kendo-react-grid'
import context from '@/context'
import Resx from '@/components/Resx'
import { personTypes } from '@/enums/PersonTypes'

@localized()
class BlackList extends React.Component {
  render () {
    const { localize, locale } = this.props
    const enumName = personTypes.enumName
    const buttons = [
      { url: x => `/blacklists/${x.id}`, icon: 'pencil' }
    ]
    return (
      <Main>
        <MainTop>
          <MainTopTitle><Resx name='Blacklists.BlacklistTitle' /></MainTopTitle>
          <MainTopLeft />
        </MainTop>
        <MainBody>
          <BsrsGrid
            persistenceId={'blacklist-exports'}
            dataSource={context.api.blacklistRecordService.getAllTableData}
            filterable>
            {NameColumn({ locale, nameProp: 'blacklistName', latinNameProp: 'blacklistLatinName', title: localize('Blacklists.Type'), editable: false })}
            <Column field='personType' title={localize('Blacklists.PersonType')} editable={false}
              cell={EnumCell({ localize, enumName })}
              filterCell={EnumFilterCell({ localize, enumName }, personTypes.values.filter(x => x !== personTypes.enum.Unknown))} enumName={enumName} />
            <Column field='personName' title={localize('Blacklists.PersonName')} editable={false} />
            <Column field='personLatinName' title={localize('Blacklists.PersonLatinName')} editable={false} />
            <Column field='validFrom' title={localize('Common.ValidFrom')} filter='date' cell={DateCell} filterCell={DateFilterCell} editable={false} />
            <Column field='validTo' title={localize('Common.ValidTo')} filter='date' cell={DateCell} filterCell={DateFilterCell} editable={false} />
            <Column field='reason' title={localize('Common.Reason')} editable={false} />
            <Column {...actionButtonsColumnProps(buttons)} />
          </BsrsGrid>
        </MainBody>
      </Main>
    )
  }
}

export default BlackList



// WEBPACK FOOTER //
// ./src/internal-app/pages/blacklistExports/list.js